import FJLocalStore from '../../../../store/FJLocalStore';
import styles from './FJVideoRemoveBgRemoverAfter.module.less';
import FJArrowBack from '../../../../assets/svg/back.svg?react';
import FJVideoRemoveBgBgContainer from '../container/FJVideoRemoveBgBgContainer';
import PropTypes from 'prop-types';
import FJButton, { FJButtonType } from '../../../../common/components/FJButton/FJButton';
import FJDownloadIcon from '../../../../assets/svg/download.svg?react';
import FJCreditIcon from '../../../../assets/svg/credits-min.svg?react';
import classNames from 'classnames';
import FJVideoRemoveBgFormateContainer from '../container/FJVideoRemoveBgFormateContainer';

const FJVideoRemoveBgRemoverAfter = ({
    goToBack,
    isShowHeader = true,
    exportVideo,
    removeAll,
    isTrimVideo,
    disabled = false,
    sourceLoadingError = false,
    isShow,
}) => {
    return (
        <div className={classNames(styles.container, { [styles.disabled]: disabled, [styles.show]: isShow })}>
            {isShowHeader && (
                <div className={styles.header_title}>
                    <FJArrowBack className={styles.header_title_back} onClick={goToBack} />
                    {FJLocalStore._('setting')}
                </div>
            )}
            <div className={classNames(styles.content, { [styles.disabled]: sourceLoadingError })}>
                <FJVideoRemoveBgBgContainer />
                <FJVideoRemoveBgFormateContainer />
            </div>

            <FJButton
                className={styles.download_btn}
                textClassName={styles.download_btn_text}
                text={
                    isTrimVideo
                        ? FJLocalStore._('download-xxx-preview-video').replace('xxx', '5s')
                        : FJLocalStore._('download')
                }
                type={FJButtonType.GRADIENT}
                onClick={exportVideo}
                disabled={sourceLoadingError}
                icon={
                    <div className={styles.download_icon}>
                        <FJDownloadIcon />
                    </div>
                }
            />

            {isTrimVideo && (
                <FJButton
                    className={styles.get_credit_btn}
                    textClassName={styles.get_credit_btn_text}
                    text={FJLocalStore._('download-full-video')}
                    type={FJButtonType.CREDIT}
                    onClick={removeAll}
                    disabled={sourceLoadingError}
                    icon={
                        <div className={styles.credit_icon}>
                            <FJCreditIcon />
                        </div>
                    }
                />
            )}
        </div>
    );
};

FJVideoRemoveBgRemoverAfter.propTypes = {
    goToBack: PropTypes.func,
    exportVideo: PropTypes.func,
    removeAll: PropTypes.func,
    isTrimVideo: PropTypes.bool,
    isShowHeader: PropTypes.bool,
    disabled: PropTypes.bool,
    isShow: PropTypes.bool,
    sourceLoadingError: PropTypes.bool,
};

export default FJVideoRemoveBgRemoverAfter;
